export { default } from './CTA'



// WEBPACK FOOTER //
// /src/js/drawer/components/BetPage/components/ActionBar/components/CTA/index.js